import { clusterId, pipelineId, writekey } from '../fixture-ids';

export const pipelineEntries = {
  PIPELINE_CREATED: {
    entity: 'pipeline',
    identity: 'record',
    idKeys: ['pipelineId'],
    renderMode: 'diff',
    createsRecord: true,
  },
  PIPELINE_UPDATED: {
    entity: 'pipeline',
    identity: 'record',
    idKeys: ['pipelineId'],
    renderMode: 'diff',
    createsRecord: false,
  },
  // Same UPDATE branch as PIPELINE_UPDATED in the trigger (deleted_at NULL -> NOT NULL); the
  // action name alone conveys the deletion.
  PIPELINE_DELETED: {
    entity: 'pipeline',
    identity: 'record',
    idKeys: ['pipelineId'],
    renderMode: 'diff',
    createsRecord: false,
  },
};

export const pipelineFixtures = {
  PIPELINE_CREATED: {
    action: 'PIPELINE_CREATED',
    debugData: {
      pipelineId,
      pipelineName: 'Web Analytics',
      writekey,
      clusterId,
    },
  },
  PIPELINE_UPDATED: {
    action: 'PIPELINE_UPDATED',
    debugData: {
      pipelineId,
      pipelineName: 'Web Analytics (Prod)',
    },
  },
  PIPELINE_DELETED: {
    action: 'PIPELINE_DELETED',
    debugData: {
      pipelineId,
      pipelineName: 'Web Analytics (Prod)',
    },
  },
};
